import { ordersReducer } from '../../orders/reducers/OrdersReducer';
import ordersSaga from '../../orders/sagas/OrdersSaga';
const loadOrdersModule = () => ({
    id: 'Orders',
    reducerMap: {
        orders: ordersReducer,
    },
    sagas: [ordersSaga],
});
export default loadOrdersModule;
